<template>
  <div>
    <top></top>
    <navMenu></navMenu>
    <div class="inner">
      <!-- <Header></Header> -->
      <!-- <nav-img></nav-img> -->
      <navbar></navbar>

      <div class="myquillEditor">
        <div class="edit_container">
          <input
            type="text"
            class="edit_containertitle"
            v-model="logtitle"
            placeholder="请输入标题"
          />
          <quill-editor
            v-model="content"
            ref="myQuillEditor"
            class="editer"
            :options="editorOption"
            @ready="onEditorReady($event)"
          >
          </quill-editor>
        </div>
        <div class="submit_btn">
          <el-button type="primary" @click="submit(1)">发表日志</el-button>
          <el-button type="primary" @click="submit(0)">存草稿箱</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import top from "@/components/common/top.vue";
import navMenu from "@/components/common/navMenu.vue";
// 引入主导航栏区域
import Header from "../../../components/space/Header";
// 引入主体背景区域
import NavImg from "../../../components/space/NavImg";
// 引入导航栏区域
import Navbar from "../../../components/space/Navbar";
import { quillEditor } from "vue-quill-editor";
import URL from "../../../api/index";
import axios from "axios";
export default {
  name: "editlog",
  data() {
    return {
      jourinfo: '',
      editorOption: {},
      logtitle: "",
      content: "",
      jourid: "",
    };
  },
  components: {
    top,
    navMenu,
    quillEditor,
    Header,
    NavImg,
    Navbar,
  },
  created() {
    // 获取用户信息、
    this.UserInfo = JSON.parse(window.localStorage.getItem("info"));
    //日志信息
    this.edittype = this.$route.query.edittype;
    if (this.edittype == 2) {
      this.jourinfo = JSON.parse(window.localStorage.getItem("jourinfo"));
      if (this.jourinfo) {
        this.logtitle = this.jourinfo.journal_title;
        this.content = this.jourinfo.journal_content;
        this.jourid = this.jourinfo.journal_id;
      }
    }
  },
  methods: {
    onEditorReady(editor) {},
    //提交
    submit(jourtype) {
      if (!this.logtitle) {
        this.$message.error("标题不能为空");
        return;
      } else {
        if (!this.jourinfo) {
          //日志信息为空 发布方法
          this.addjour(jourtype);
        } else {
          //有日志信息 编辑方法
          this.updatejour(jourtype);
        }
      }
    },
    // 发布日志数据上报
    getRecordNew(hh, row) {
      axios.get("https://access.rujiaowang.net/GetLogServer").then((res) => {
        this.client_ip = res.data.result.client_ip;
        var differenctime =
          res.data.result.net_ts - Date.parse(new Date()) / 1000;
        // 进入空间
        var saydata = {
          product_name: "教师工作台",
          log_version: "v2.0.1",
          action: "studyspace_publish",
          user_id: String(hh.user_id),
          user_role: String(hh.user_type),
          user_name: String(hh.user_nicename),
          ts: String(Number(Date.parse(new Date())) / 1000 + differenctime),
          trace_id: JSON.parse(localStorage.getItem("data_traceid")),
          dev_id: "",
          dev_name: "",
          client_ip: this.client_ip,
          os: "",
          cpu_name: "",
          cpu_use: "",
          app_version: "v2.0.0",
          mem_size: "",
          mem_use: "",
          net: "",
          electric: "",
          extend: "",
          remark: `${hh.user_nicename}` + "使用了网络学习空间的发表功能",
          data: {
             function: "日志",
            school_name: hh.teacher_info.school_name
              ? `${hh.teacher_info.school_name}`
              : "",
            school_id: hh.teacher_info.school_id
              ? `${hh.teacher_info.school_id}`
              : "",
            trace_id: JSON.parse(localStorage.getItem("space_traceid")),
            source: "",
            title: this.logtitle,
            content: this.content,
            whither: row,
          },
        };
        axios.post("http://47.114.114.56:9002/RecordRjw", saydata);
      });
    },
    // 编辑日志数据上报
    getRecordRjw(hh, row) {
      axios.get("https://access.rujiaowang.net/GetLogServer").then((res) => {
        this.client_ip = res.data.result.client_ip;
        var differenctime =
          res.data.result.net_ts - Date.parse(new Date()) / 1000;
        // 进入空间
        var saydata = {
          product_name: "教师工作台",
          log_version: "v2.0.1",
          action: "studyspace_logcompile",
          user_id: String(hh.user_id),
          user_role: String(hh.user_type),
          user_name: String(hh.user_nicename),
          ts: String(Number(Date.parse(new Date())) / 1000 + differenctime),
          trace_id: JSON.parse(localStorage.getItem("data_traceid")),
          dev_id: "",
          dev_name: "",
          client_ip: this.client_ip,
          os: "",
          cpu_name: "",
          cpu_use: "",
          app_version: "v2.0.0",
          mem_size: "",
          mem_use: "",
          net: "",
          electric: "",
          extend: "",
          remark: `${hh.user_nicename}` + "使用了网络学习空间的日志编辑功能",
          data: {
            school_name: hh.teacher_info.school_name
              ? `${hh.teacher_info.school_name}`
              : "",
            school_id: hh.teacher_info.school_id
              ? `${hh.teacher_info.school_id}`
              : "",
            trace_id: JSON.parse(localStorage.getItem("space_traceid")),
            source: this.jourinfo.draft=="1"?"已发布":"草稿箱",
            title: this.logtitle,
            content: this.content,
            whither: row,
          },
        };
        axios.post("http://47.114.114.56:9002/RecordRjw", saydata);
      });
    },
    //存在 编辑
    updatejour(jourtype) {
      var draftType;
      if(jourtype==1){
        draftType='发表日志'
      }else{
        draftType="存草稿箱"
      }
      this.getRecordRjw(JSON.parse(localStorage.getItem("loginInfo")),draftType)
      var upjourinfo = {
        token: this.UserInfo.token,
        title: this.logtitle,
        content: this.content,
        draft: jourtype,
        journal_id: this.jourid,
      };
      this.$post(URL.updatejournal, upjourinfo).then((res) => {
        if (res.state == 0) {
          localStorage.removeItem("jourinfo");
          this.$router.push("/space/journal");
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 发布日志 draft 1为发布日志 0 为草稿箱
    addjour(jourtype) {
      var draftType;
      if(jourtype==1){
        draftType='发表日志'
      }else{
        draftType="存草稿箱"
      }
      this.getRecordNew(JSON.parse(localStorage.getItem("loginInfo")), jourtype) 
      var addjourinfo = {
        token: this.UserInfo.token,
        title: this.logtitle,
        content: this.content,
        draft: jourtype,
      };
      this.$post(URL.addjournal, addjourinfo).then((res) => {
        if (res.state == 0) {
          this.$router.push("/space/journal");
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>
<style >
.box {
  padding-top: 20px;
}
.edit_container {
  /* width: 1200px; */
  padding: 40px;
  margin-bottom: 40px;
}
.editer {
  height: 350px;
}
.submit_btn {
  text-align: center;
}
.edit_containertitle {
  width: 100%;
  height: 40px;
  line-height: 40px;
  border: 1px solid #ccc;
  border-bottom: none;
  outline: none;
  text-indent: 2em;
}
.router-link-active {
  color: #8fc526 !important;
  border-top: 4px solid #8fc526 !important;
}
</style>